import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';

const DisclosureGuidelinesStakeholderAnalysis = () => {
  const [opened, { open, close }] = useDisclosure();

  return (
    <Box>
      <Button color="inherit" startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>
      <DisclosureGuidelineModal
        open={opened}
        onClose={close}
        title="การวิเคราะห์ผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจ"
        description={
          <>
            <Typography sx={{ textIndent: 90 }}>
              ให้ระบุกลุ่มผู้มีส่วนได้เสียที่สำคัญทั้งภายในและภายนอกองค์กรซึ่งมีความสัมพันธ์กับห่วงโซ่คุณค่าของธุรกิจ
              โดยสรุปความคาดหวังของผู้มีส่วนได้เสียที่มีต่อการดำเนินธุรกิจของบริษัท
              อีกทั้งควรอธิบายถึงการตอบสนองความคาดหวังของผู้มีส่วนได้เสียดังกล่าว
            </Typography>
            <Typography
              fontWeight="bold"
              sx={{
                textDecoration: 'underline',
                textIndent: 90,
              }}
              mb={-2}
            >
              คำแนะนำหรือคำอธิบายเพิ่มเติม
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              ผู้มีส่วนได้เสีย (Stakeholder) คือ
              บุคคลหรือหน่วยงานที่มีความเกี่ยวข้องกับการดำเนินธุรกิจของบริษัทในทางตรงและ/หรือทางอ้อม
              โดยแบ่งเป็น 1) ผู้มีส่วนได้เสียภายในองค์กร เช่น ผู้ถือหุ้น พนักงาน
              2) ผู้มีส่วนได้เสียภายนอกองค์กร เช่น ลูกค้า คู่ค้า ชุมชน
              บริษัทควรระบุผู้มีส่วนได้เสียทั้งภายในและภายนอกองค์กร
              รวมถึงอธิบายความคาดหวังของผู้มีส่วนได้เสียและแสดงให้เห็นแนวทางการตอบสนองความคาดหวังของผู้มีส่วนได้เสียเหล่านั้น
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              บริษัทควรประเมินความคาดหวังของผู้มีส่วนได้เสียอย่างน้อยปีละ 1
              ครั้ง ผ่านกระบวนการรับฟังความคิดเห็นการสำรวจความพึงพอใจ การประชุม
              หรือช่องทางการมีส่วนร่วมอื่นๆ
              เพื่อให้ทราบผลกระทบและประเด็นที่เกี่ยวโยงระหว่างบริษัทและผู้มีส่วนได้เสียทั้งด้านบวกและลบ
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              เมื่อทราบความคาดหวังของผู้มีส่วนได้เสียแต่ละกลุ่มแล้ว
              ให้ระบุแนวทางการตอบสนองความคาดหวังของผู้มีส่วนได้เสียแต่ละกลุ่ม
              โดยสะท้อนให้เห็นถึงความร่วมมือและการสร้างคุณค่าร่วมกันระหว่างธุรกิจกับผู้มีส่วนได้เสียเพื่อลดความเสี่ยงและสร้างมูลค่าเพิ่มให้แก่ธุรกิจ
            </Typography>
            <Typography
              sx={{
                textDecoration: 'underline',
                textIndent: 90,
              }}
              mt={4}
            >
              ตัวอย่าง ตารางการวิเคราะห์ผู้มีส่วนได้เสียบนห่วงโซ่คุณค่าของธุรกิจ
            </Typography>
            <Box
              component="img"
              width={1}
              alt="TableStakeholderAnalysis"
              src="/assets/disclosure/TableStakeholderAnalysis.png"
              mt={2}
            />
          </>
        }
      />
    </Box>
  );
};

export default DisclosureGuidelinesStakeholderAnalysis;
